export default "__VITE_ASSET__4pfTmwMa__"